import React from "react";
import {
    Modal,
    Button,
    ConfigProvider
} from 'antd'
import { useNavigate } from "react-router-dom";
import { clearStorage, getDataPercipio, getDataSso } from "../utils";
import { useDispatch, useSelector } from 'react-redux'
import { setInvalidToken } from '../redux/features/main/invalidTokenSlice'
import { logoutSSOWithPopup } from "../services/authService";

// color config
import { textTitleHome, checkCircleIcon } from '../config/constant/color/index'

const ModalInvalidToken = ({ invalidTokenPopup, setInvalidTokenPopup }) => {
  const remoteProperty = useSelector((state) => state.remote.remoteProperty);
    const dispatch = useDispatch()
    var navigate = useNavigate();
    const urlLogin = import.meta.env.VITE_AUTH0_LOGIN_URL;

    const onClickBtnPopup = async () => {
        setInvalidTokenPopup(false);
        dispatch(setInvalidToken(0));
        if(!remoteProperty.isUsedSSO) clearStorage();

        if(!remoteProperty.isUsedSSO){
            navigate(`${import.meta.env.BASE_URL}login`);
        } else {
            if (remoteProperty.isUsedSSO && !remoteProperty.isUsedPopupSSO) {
                window.location.href = urlLogin;
                clearStorage();
            } else {
                await logOutPercipioAndSSOWithPopup();
            }
        }
    }

    const logOutPercipioAndSSOWithPopup = async () => {
        try {
            await handleLogoutPercipioForInvalidToken();
            await logoutSSOWithPopup();

        } catch (err) {
            console.error(err);
            navigate(`${import.meta.env.BASE_URL}login`);
        } finally {
            clearStorage();
        }
    };

    const handleLogoutPercipioForInvalidToken = () => {
        
        // Get Percipio logout URL from localStorage
        const percData = getDataPercipio();
        const logoutUrl = percData.url_logout;
        const isShowPercipio = percData.is_show_percipio == "true";

        const isValidUrl = (url) => {
            try {
                new URL(url);
                return true;
            } catch {
                return false;
            }
        };

        // Open Percipio logout page in a new tab if URL exists
        if (isShowPercipio && isValidUrl(logoutUrl)) {

            const w = window.open(logoutUrl, "_blank", "width=480,height=640");

            let closed = false;

            const maxTime = 12000;
            const minTime = 3000;
            const start = Date.now();

            const interval = setInterval(() => {
                if (!w || w.closed) {
                clearInterval(interval);
                return;
                }

                const elapsed = Date.now() - start;

                // jangan tutup terlalu cepat
                if (elapsed > minTime) {
                try {
                    // akses location akan throw error cross-origin
                    w.location.href;
                } catch {
                    // ini justru indikasi halaman sudah navigasi
                    if (elapsed > maxTime) {
                    w.close();
                    // handleLogOut();
                    navigate(`${import.meta.env.BASE_URL}login`);
                    clearInterval(interval);
                    }
                }
                }
            }, 500);
        } else {
        // handleLogOut();
        }
    };
    return (
        <ConfigProvider
            theme={{
                components: {
                    Modal: {
                        borderRadiusLG: '24px'
                    }
                },
                token: {
                    fontFamily: 'Roboto'
                }
            }}
        >
            <Modal
                open={invalidTokenPopup}
                maskClosable="false"
                closeIcon={false}
                width={420}
                centered
                footer={null}>
                <div style={{ textAlign: 'center', padding: '32px' }}>
                    <div style={{ fontSize: '22px', color: textTitleHome, marginBottom: 16, fontWeight: '500' }}>
                        Oops
                    </div>
                    <p style={{ color: textTitleHome }}>
                        Invalid or Expired Token
                    </p>
                    <Button
                        className="btn btn-sm btn-primary btn-block"
                        style={{ borderRadius: '6px', border: 'none', fontWeight: '500', marginTop: '30px', height: '48px' }}
                        name="btn-ok-invalid"
                        onClick={() => onClickBtnPopup()}>
                        OK
                    </Button>
                </div>
            </Modal>
        </ConfigProvider>
    )
}

export default ModalInvalidToken